var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"video",staticClass:"shaka",attrs:{"autoplay":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }